import { render, staticRenderFns } from "./BeeBreadcrumbs.vue?vue&type=template&id=3c4cf336&scoped=true"
import script from "./BeeBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./BeeBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./BeeBreadcrumbs.vue?vue&type=style&index=0&id=3c4cf336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4cf336",
  null
  
)

export default component.exports